import { InjectionToken } from '@angular/core';
import { LivechatConfigurationInterface } from '@app/core/livechat/livechat.interfaces';

/** @deprecated - this is moved to libs */
export const LIVECHAT_CONFIGURATION = new InjectionToken<LivechatConfigurationInterface>('LivechatConfiguration');
